export default __webpack_public_path__ + "static/media/expl_gradcam_08_DE.cb801c6e.png";